
<script>
import store from '../store';
export default {
    computed: {
        image() {
            // console.log(store.data)
            return store.data.head.images[0];
        }
    }
}
</script>

<template>
    <div class="wrap">
        <img :src="image" alt="">
    </div>
</template>

<style lang="stylus" scoped>
.wrap img
    width 100%
</style>